var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEuro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#D2D2D2",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4,13.5H6.111A11.218,11.218,0,0,1,6,12a11.218,11.218,0,0,1,.111-1.5H4a1,1,0,0,1,0-2H6.571A8.983,8.983,0,0,1,14.857,2a7.962,7.962,0,0,1,3.59.854,1,1,0,0,1-.894,1.79A5.98,5.98,0,0,0,14.857,4,6.857,6.857,0,0,0,8.7,8.5H14a1,1,0,0,1,0,2H8.125a9.062,9.062,0,0,0,0,3H13a1,1,0,0,1,0,2H8.7A6.857,6.857,0,0,0,14.857,20a5.98,5.98,0,0,0,2.7-.644,1,1,0,0,1,.894,1.79,7.962,7.962,0,0,1-3.59.854,8.983,8.983,0,0,1-8.286-6.5H4a1,1,0,0,1,0-2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEuro);
export default __webpack_public_path__ + "static/media/euro.e15cb024ca34e149503ca4361c913d1d.svg";
export { ForwardRef as ReactComponent };